import { create } from 'zustand';

interface GetStartedDialogState {
  isOpen: boolean;
  shouldHoldNotifications: boolean;
  openDialog: () => void;
  closeDialog: (create?: boolean) => void;
  openMerchantSupportPopup: () => void;
  setShouldHoldNotifications: (hold: boolean) => void;
}

const useGetStartedDialogStore = create<GetStartedDialogState>((set) => ({
  isOpen: false,
  shouldHoldNotifications: false,
  openDialog: () => set({ isOpen: true, shouldHoldNotifications: true }),
  closeDialog: (create = false) => set({ isOpen: false, shouldHoldNotifications: false }),
  openMerchantSupportPopup: () => set({ isOpen: true, shouldHoldNotifications: true }),
  setShouldHoldNotifications: (hold) => set({ shouldHoldNotifications: hold }),
}));

export default useGetStartedDialogStore;
